import {
    GET_ALL_AUCTIONS,
    GET_SINGLE_AUCTION,
    GET_AUCTION_PROJECTS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_LOT,
    GET_ALL_MAIN_LOT_COUNT,
} from './auctionTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_AUCTIONS:
            return {
                ...state,
                all_auctions: action.payload,
            }
        case GET_SINGLE_AUCTION:
            return {
                ...state,
                single_auction: action.payload,
            }
        case GET_ALL_MAIN_LOT_COUNT:
            return {
                ...state,
                all_bid_lot_count: action.payload.all_bid_lot_count,
            }
        case GET_AUCTION_PROJECTS:
            return {
                ...state,
                auction_projects: action.payload,
            }
        case GET_ALL_LOT:
            return {
                ...state,
                all_lot_count: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
